import React, {Fragment, memo} from 'react';
import {useSelector} from 'react-redux';

import {viewSelector} from '@mapsight/ui/src/js/store/selectors';
import {VIEW_MOBILE} from '@mapsight/ui/src/js/config/constants/app';

import {detailsSelector} from '../store/selectors';
import {withErrorBoundary} from '../../modules/error-boundary';
import {memoForever} from '../../modules/helpers';

import {useNavPos} from '../../hooks';

import PageHead from '../../stade/components/page-head';
import DetailsContent from '../../stade/components/details-content';
import DetailsImpressions from '../../stade/components/details-impressions';
import Ratings from '../../ratings/components/ratings';
import StadeList from '../../stade/components/list';
import RatingWidget from '../../stade/components/rating-widget';


/** @type {import("@mapsight/ui/src/js/components/contexts").AppWrapperStart} */
const AppWrapperStart = withErrorBoundary(memo(function AppWrapperStart({}) {
		const navPos = useNavPos();
		const isMobile = useSelector(state => viewSelector(state) === VIEW_MOBILE);
		const details = useSelector(detailsSelector);

		// const menuButtonRef = useRef();
		// return ...
		// 	<MenuButton ref={menuButtonRef} />
		// 	<Menu buttonRef={menuButtonRef} />
		//
		const content =
			!isMobile ? null : (
				(navPos.list || navPos.listMorePoi) ? (<StadeList />) :
					(details || navPos.home ?
						<DetailsContent /> :
						null)
			);

		return (
			<Fragment>
				<PageHead />
				{content &&
					<div className="ms3-map-row [ ms3-flex ms3-flex-grow ms3-flex--row ]">
						<div className="ms3-flex ms3-flex--column">
							{content}
						</div>
					</div>
				}
				{isMobile &&
					<Fragment >
						<RatingWidget />
						<DetailsImpressions />
					</Fragment>
				}
				{isMobile && navPos.deepLink && navPos.withStarsRating &&
					<Ratings />
				}
			</Fragment>
		);
	},
	memoForever
));
export default AppWrapperStart;
